//LIBRARYS
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
// import { Amplify } from "aws-amplify";

//COMPONENTS
import Navbar from "../components/layouts/Navbar";
import Footer from "../components/layouts/Footer";

//PAGES
import HomeMain from "../pages/home/Home.Main";
import ProfileMain from "../pages/profile/Profile.Main";
import FaqMain from "../pages/faq/Faq.Main";
import OrderMain from "../pages/order/Order.Main";
import OrderDetail from "../pages/order/Order.Detail";
import AddressMain from "../pages/address/Address.Main";
import ContactMain from "../pages/contactus/Contact.Main";
import AboutUsMain from "../pages/aboutus/Aboutus.Main";
import PrivacyMain from "../pages/privacy/Privacy.Main";
import TermMain from "../pages/term/Term.Main";
import MoreMain from "../pages/more/More.Main";
import LoginMain from "../pages/login/Login.Main";
import ProgramMain from "../pages/task/Program.Main";
import { ContextLanguage } from "../context/Context.Language";
import BusketMain from "../pages/basket/Basket.Main";
import { Toastify } from "../components/tostify/RenderToastify";
import SelectMain from "../pages/select/Select.Main";
import GlossaryMain from "../pages/glossary/Glossary.Main";
import PattayaMain from "../pages/pattaya/Pattaya.Main";
import BangkokMain from "../pages/bangkok/Bangkok.Main";
import PricingMain from "../pages/pricing/Pricing.Main";
import { IconFloat } from "../components/iconfloat/Icon.Float";
import { useSelector } from "react-redux";
import OrderReceived from "../pages/orderReceived/OrderReceived.Main";
import ProfileComplteProfile from "../pages/profile/render/Profile.CompleteProfile";

const KeepHistory = (props) => {
  const { history, setHistory } = props;
  const location = useLocation();

  React.useEffect(() => {
    if (history.page !== location.pathname) {
      setHistory({
        page: location.pathname,
        state: [],
      });
    }
  }, [location]);

  return <div>{props?.children}</div>;
};

const ContactUsTH = () => {
  const navigate = useNavigate();
  const { FunctionChangeLanguageTo } = React.useContext(ContextLanguage);

  React.useEffect(() => {
    FunctionChangeLanguageTo("TH");
    navigate("/ContactUs");
  }, []);
  return <React.Fragment />;
};

const ContactUsEN = () => {
  const navigate = useNavigate();
  const { FunctionChangeLanguageTo } = React.useContext(ContextLanguage);

  React.useEffect(() => {
    FunctionChangeLanguageTo("EN");
    navigate("/ContactUs");
  }, []);

  return <React.Fragment />;
};

const MainRouter = () => {
  const { language } = React.useContext(ContextLanguage);
  const [width, setWidth] = React.useState(0);
  const [history, setHistory] = React.useState({ page: "/", state: [] });

  const [programs, setPrograms] = React.useState({});
  const [config, setConfig] = React.useState({});
  const [addons, setAddons] = React.useState({});
  const [addons_no_index, setAddonsNoIndex] = React.useState({});

  const { user } = useSelector((state) => state.auth);

  const { banner } = useSelector((state) => state.loadBanner);

  const {
    addons: a,
    config: b,
    programs: c,
    // banner,
    addons_no_index: d,
    version,
  } = useSelector((state) => state.loadData);

  React.useEffect(() => {
    setAddons(a);
    setConfig(b);
    setPrograms(c);
    setAddonsNoIndex(d);
  }, [a, b, c, d]);

  const refScreen = React.useRef();

  const navigate = useNavigate();
  const location = useLocation();

  const thisAddons = language === "TH" ? addons?.TH : addons?.EN;
  const thisAddonsNoIndex =
    language === "TH" ? addons_no_index?.TH : addons_no_index?.EN;
  const thisConfig = language === "TH" ? config?.TH : config?.EN;
  const thisPrograms =
    language === "TH" ? programs?.TH?.programs : programs?.EN?.programs;

  React.useEffect(() => {
    setTimeout(() => {
      setWidth(refScreen?.current?.clientWidth);
    }, [500]);
  }, []);

  React.useEffect(() => {
    if (
      user?._id &&
      (!user?.full_name || !user?.email) &&
      location.pathname !== "/CompleteProfile"
    ) {
      navigate("/CompleteProfile");
    }
    return () => {};
  }, [user, location]);

  //CONSTANTS

  const MENU = [
    {
      path: "/",
      element: (
        <HomeMain
          programs={thisPrograms}
          config={thisConfig}
          width={width}
          banner={banner}
        />
      ),
      //   protected: true,
    },
    {
      path: "/TH",
      element: (
        <HomeMain
          programs={thisPrograms}
          config={thisConfig}
          width={width}
          banner={banner}
        />
      ),
      //   protected: true,
    },
    {
      path: "/th",
      element: (
        <HomeMain
          programs={thisPrograms}
          config={thisConfig}
          width={width}
          banner={banner}
        />
      ),
      //   protected: true,
    },
    {
      path: "/Basket",
      element: <BusketMain config={thisConfig} width={width} />,
      //   protected: true,
    },
    {
      path: "/Login",
      element: <LoginMain />,
    },
    {
      path: "/MyOrders",
      element: <OrderMain />,
      //   protected: true,
    },
    {
      path: "/MyOrders/:id",
      element: <OrderDetail />,
      //   protected: true,
    },
    {
      path: "/MyProfile",
      element: <ProfileMain />,
      //   protected: true,
    },
    {
      path: "/Address",
      element: <AddressMain history={history} setHistory={setHistory} />,
      //   protected: true,
    },
    {
      path: "/Pricing",
      element: (
        <PricingMain
          programs={thisPrograms}
          addons={thisAddons}
          config={thisConfig}
        />
      ),
    },
    {
      path: "/Pricing/TH",
      element: (
        <PricingMain
          programs={thisPrograms}
          addons={thisAddons}
          config={thisConfig}
        />
      ),
    },
    {
      path: "/FAQ",
      element: <FaqMain />,
    },
    {
      path: "/FAQ/TH",
      element: <FaqMain />,
    },
    {
      path: "/ContactUs",
      element: <ContactMain />,
    },
    {
      path: "/ContactUs/TH",
      element: <ContactMain />,
    },
    {
      path: "/AboutUs",
      element: <AboutUsMain />,
    },
    {
      path: "/AboutUs/TH",
      element: <AboutUsMain />,
    },
    {
      path: "/PrivacyNotice",
      element: <PrivacyMain />,
    },
    {
      path: "/PrivacyNotice/TH",
      element: <PrivacyMain />,
    },
    {
      path: "/TermsAndConditions",
      element: <TermMain />,
    },
    {
      path: "/TermsAndConditions/TH",
      element: <TermMain />,
    },
    {
      path: "/Program",
      element: (
        <ProgramMain programs={thisPrograms} addons={thisAddonsNoIndex} />
      ),
    },
    {
      path: "/OurServices",
      element: <SelectMain programs={thisPrograms} config={thisConfig} />,
    },
    {
      path: "/OurServices/TH",
      element: <SelectMain programs={thisPrograms} config={thisConfig} />,
    },
    // {
    //   path: "/Glossary",
    //   element: <GlossaryMain programs={thisPrograms} addons={thisAddons} />,
    // },
    // {
    //   path: "/Glossary/TH",
    //   element: <GlossaryMain programs={thisPrograms} addons={thisAddons} />,
    // },
    {
      path: "/Pattaya",
      element: <PattayaMain programs={thisPrograms} addons={thisAddons} />,
    },
    {
      path: "/Pattaya/TH",
      element: <PattayaMain programs={thisPrograms} addons={thisAddons} />,
    },
    {
      path: "/Bangkok",
      element: <BangkokMain programs={thisPrograms} addons={thisAddons} />,
    },
    {
      path: "/Bangkok/TH",
      element: <BangkokMain programs={thisPrograms} addons={thisAddons} />,
    },

    {
      path: "/OrderReceived",
      element: <OrderReceived />,
    },
    {
      path: "/CompleteProfile",
      element: <ProfileComplteProfile />,
    },
    {
      path: "/ContactUsTH",
      element: <ContactUsTH />,
    },
    {
      path: "/ContactUsEN",
      element: <ContactUsEN />,
    },
    {
      path: "/MyWash",
      element: (
        <ProgramMain
          programs={thisPrograms}
          addons={thisAddonsNoIndex}
          page="mywash"
        />
      ),
    },
    {
      path: "/MyIron",
      element: (
        <ProgramMain
          programs={thisPrograms}
          addons={thisAddonsNoIndex}
          page="myiron"
        />
      ),
    },
    {
      path: "/MyShoes",
      element: (
        <ProgramMain
          programs={thisPrograms}
          addons={thisAddonsNoIndex}
          page="myshoe"
        />
      ),
    },
    // {
    //   path: "/Payment",
    //   element: <PaymentMain />,
    // },
  ];

  // const location = useLocation();
  // console.log(" window.pathname", window.pathname);
  // if (!banner || !thisPrograms) return <React.Fragment />;

  return (
    <React.Fragment>
      <div id="first-div"></div>
      <div
        className={`overflow-x-hidden  ${
          language === "TH" ? " font-NotoSansThai " : " font-Poppins "
        }  `}
      >
        <div className={`  flex flex-col flex-1 w-full relative  bg-white `}>
          <Navbar refScreen={refScreen} />
          <Toastify />
          <IconFloat />
          <div
            className={` mb-auto <0> ${
              location.pathname === "/MyOrders"
                ? " bg-white md:bg-laundry-borderbottomline "
                : ""
            } `}
          >
            <Routes>
              {MENU.map((route, index) => {
                return (
                  <Route
                    key={`key-route-non-protect-${index}`}
                    path={route.path}
                    element={
                      <KeepHistory history={history} setHistory={setHistory}>
                        {route.element}
                      </KeepHistory>
                    }
                  />
                );
              })}
            </Routes>
          </div>
          <Footer programs={programs} config={config} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default MainRouter;
